'use strict';

app.service('$preloader', function () {
  var count = 0;
  this.state = function () {
    return !!count;
  };
  this.show = function () {
    count++;
  };
  this.hide = function () {
    count--;
  };
});

app.config(function ($provide) {
  $provide.decorator('$state', function ($delegate, $q, $document, $preloader) {
    var $state = $delegate;
    var transitionTo = $state.transitionTo;
    $state.transitionTo = function () {
      // console.log(_.cloneDeep(_.toArray(arguments)));
      var args = _.toArray(arguments);
      $document[0].activeElement.blur();
      $preloader.show();
      var transition = $q.when().then(function () {
        return transitionTo.apply($state, args);
      });
      return transition.finally($preloader.hide);
    };
    return $state;
  });
});

// app.run(function ($rootScope, $preloader) {
//   $rootScope.$on('$stateChangeStart', $preloader.show);
//   $rootScope.$on('$stateChangeError', $preloader.hide);
//   $rootScope.$on('$stateChangeSuccess', $preloader.hide);
//   $rootScope.$on('$stateChangeCancel', $preloader.hide);
// });
